import { Clock } from 'lucide-react';
import { Card } from '@/shared/ui/Card';
import patterns from '@/shared/ui/styles/patterns.module.css';
import styles from './CaptureTab.module.css';

const HOW_IT_WORKS_STEPS = [
  { label: 'SMS / link', desc: 'Patient receives or scans a short link from your office.' },
  { label: 'Tap answers', desc: '"What stood out today?" — 2 quick-tap questions, no typing.' },
  {
    label: 'Draft',
    desc: 'A short first-person draft is assembled from their own taps, fully editable.',
  },
  {
    label: 'Open Google',
    desc: "Patient posts from their own Google account — you can't do it for them.",
  },
  {
    label: 'Confirm',
    desc: 'Back on the link, they confirm the review went live. Only then does it count here.',
  },
  {
    label: 'Or tell you privately',
    desc: 'Both options always shown. The patient decides. No gating.',
  },
];

export function HowItWorks() {
  return (
    <Card padding="lg">
      <div className={patterns.panelTitle}>
        <Clock size={16} aria-hidden /> How it works for the patient
      </div>
      <ol className={styles.stepsList}>
        {HOW_IT_WORKS_STEPS.map((step, i) => (
          <li key={i} className={styles.step}>
            <span className={styles.stepNum}>{i + 1}</span>
            <div>
              <span className={styles.stepLabel}>{step.label}</span>
              <span className={styles.stepDesc}> — {step.desc}</span>
            </div>
          </li>
        ))}
      </ol>
    </Card>
  );
}
